export const APP_LABELS = {
        LOGIN_ERROR_MSG : "Please check your username and password. If you still can't log in, contact your Salesforce administrator."
    

}